/*=========================================================================================
  File Name: moduleShopState.js
  Description: Shop State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
   
};
